.dynamic-form-wrapper {
  display: flex;
  flex-flow: row wrap;

  gz-dynamic-form-input {
    width: calc(80% - 50px);
  }
  #add-new {
    margin-left: 15px;
  }
}
.dynamic-input {
  display: flex;

  gz-form-field {
    width: 100%;
  }

  #delete {
    margin-left: 15px;
  }
}
